<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة  تقرير تحويل صنف  من الي
        <br />
        {{ $route.query.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير تقرير تحويل صنف  لـ {{ $route.query.name }} من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/color.png"
                alt="Accurate"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
            
        
            </div>
          </div>
        </div>
        <hr />
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">العدد</th>
              <th scope="col">مخزن من</th>
              <th scope="col">مخزن الي</th>
              <th scope="col">موظف مخزن من</th>
              <th scope="col">موظف مخزن الي</th>
              <th scope="col">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <td>{{ f.item_num }}</td>
              <td>{{ f.fatwora ? f.fatwora.store_name_from : '' }}</td>
              <td>{{ f.fatwora ? f.fatwora.store_name_to : '' }}</td>
              <td>{{ f.fatwora ? f.fatwora.emp_name_store_from : '' }}</td>
              <td>{{ f.fatwora ? f.fatwora.emp_name_store_to : '' }}</td>
              <td>{{ f.created_at.substr(0,10) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { StoreOneItemTransferReport } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],

      all_of_total: "",
      all_total: "",
      num: "",
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("branch_id", this.$route.query.id);
      frmData.append("item_id", this.$route.query.item_id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      StoreOneItemTransferReport(frmData).then(response => {
        response.data.length > 0
          ? (this.fatworas = response.data)
          : (this.fatworas = []);

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
